import styled from 'styled-components';
import Select from 'react-select';
import { media } from '@/themes';

export default styled(Select).attrs({ classNamePrefix: 'select' })`
  min-width: calc(25% + 1em);
  padding: 0 !important;

  ${media.sm`
    width: 100%;
  `};

  .select {
    &__control {
      background-color: #FCFCFC;
      border: none;
      border-right: 1px solid rgba(0, 0, 0, .025) !important;
      border-radius: 1.5em !important;
      border-bottom-right-radius: 0 !important;
      border-top-right-radius: 0 !important;
      box-shadow: none;
      cursor: pointer;
      height: 3em;
      max-width: none;
      min-width: 15em;
      outline: none;
      padding-left: .75em;
      transition: none;

      ${media.sm`
        border-radius: 1.5em;
        border-right: none;
        box-shadow: ${({ theme }) => theme.shadows.primary};
      `};

      &:hover, &:focus, &--is-focused {
        border: none;
        border-right: 1px solid rgba(0, 0, 0, .025) !important;
        transform: none !important;
      }

      &--menu-is-open {
        border-top-left-radius: 1.5em !important;
        border-bottom-left-radius: 0 !important;

        ${media.sm`
          border-bottom-right-radius: 0;
        `};

        .select {
          &__single-value {
            opacity: .35;
          }
        }
      }
    }

    &__indicator-separator {
      display: none;
    }

    &__menu {
      background-color: #FCFCFC;
      border-radius: 0 0 .25em .25em;
      box-shadow: ${props => props.theme.shadows.primary} !important;
      margin: -.0625em 0 0;
      z-index: 10;
      color: #333;
    }

    &__option {
      &--is-focused {
        background: ${props => props.theme.colors.typography.subtle} !important;
        color: white;
      }

      &--is-selected {
        background: ${props => props.theme.colors.typography.primary} !important;
        color: white;
      }
    }
  }
`;
